module.exports = __webpack_public_path__ + "img/daren_4.7119dc84.png";